// extracted by mini-css-extract-plugin
export var container = "_2f-0";
export var disabled = "_2f-3";
export var enabled = "_2f-2";
export var statusLight = "_2f-1";